import EnvironmentManager from 'Utils/environmentManager';
import { SPORT_TYPE_BY_URL } from 'Store/constants/sportTypes';

export const generateSportTypeIcons = profession => {
  if (!profession) return '';
  
  if (typeof profession === 'number') {
    return EnvironmentManager.sportTypeHash[profession] || '';
  }
  
  if (typeof profession === 'string') {
    const normalizedProfession = profession.toLowerCase().replace(/_/g, '-').replace(/\s+/g, '-');
    const sportId = SPORT_TYPE_BY_URL[normalizedProfession];
    
    if (sportId) {
      return EnvironmentManager.sportTypeHash[sportId] || '';
    }
  }
  
  return '';
};

